import { IVisitor } from './types';

const byTimes = (first: IVisitor, second: IVisitor): number => {
  const firstDateToCompare = first.outAt ?? first.inAt;
  const secondDateToCompare = second.outAt ?? second.inAt;

  if (firstDateToCompare > secondDateToCompare) {
    return -1;
  }

  return firstDateToCompare < secondDateToCompare ? 1 : 0;
};

export default byTimes;
